// extracted by mini-css-extract-plugin
module.exports = {"window":"NavbarMonthPicker_window__2vRnQ","year":"NavbarMonthPicker_year__34Lcu"};